import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import classNames from 'classnames/bind';
import SizeSwitcher from "../SizeSwitcher";
import styles from "./styles.pcss";
var fadeVariantsChildren = {
  initial: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: 'easeInOut'
    }
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      delay: 0.3,
      ease: 'easeInOut'
    }
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.2,
      duration: 0.6,
      ease: 'easeInOut'
    }
  }
};
var cx = classNames.bind(styles);
export var ContentWrapper = function ContentWrapper(_ref) {
  var activeTab = _ref.activeTab,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false,
    "data-t-id": "components-ContentWrapper"
  }, /*#__PURE__*/React.createElement(SizeSwitcher, {
    contentKey: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title,
    "data-t-id": "components-ContentWrapper"
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: "visible",
    className: cx('content-wrapper'),
    exit: "exit",
    initial: "initial",
    key: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title,
    variants: fadeVariantsChildren
  }, children)));
};